import HomeSection from './HomeSection';
import AboutSection from './AboutSection';
import TrekSection from './TrekSection';
import TravelSection from './TravelSection';
import GallerySection from './GallerySection';


const Home = ({ backgroundImage, backgroundPosition, darkMode, setDarkMode }) => {
    return (
        <>
            <HomeSection backgroundImage={backgroundImage} backgroundPosition={backgroundPosition} darkMode={darkMode} setDarkMode={setDarkMode} />
            <AboutSection />
            <TravelSection />
            <TrekSection />
            <GallerySection />
        </>
    );
}

export default Home;